import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";

export function useSetPaymentIntentId(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  return useCallback(
    (paymentIntentId: string) => {
      setDraft((prev) => (prev ? { ...prev, paymentIntentId } : prev));
    },
    [setDraft],
  );
}
